import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { getCreatorProfileUrl, getSmartImage } from '../../helpers/helpers';

function CreatorInfo({ user }) {
  const [failedImage, setFailedImage] = useState(null);
  const handles = (user.social_links || '')
    .split(',')
    .map(link => {
      try {
        return new URL(link.trim()).pathname
          .split('/')
          .filter(Boolean)
          .pop();
      } catch {
        return null;
      }
    })
    .filter(Boolean);
  return (
    <>
      <div className='circle-creator-portrait'>
        {user.image && failedImage !== user.image ? (
          <img src={getSmartImage(user.image)} alt='' loading='lazy' onError={() => setFailedImage(user.image)} />
        ) : (
          <span role='img' aria-label={user.username ? 'No profile photo' : 'Unavailable creator'}>
            {user.username
              ? (user.name || user.username)
                  .split(' ')
                  .slice(0, 2)
                  .map(part => part[0])
                  .join('')
              : '?'}
          </span>
        )}
      </div>
      <div className='circle-info'>
        <strong>{user.name}</strong>
        <small>
          {user.username ? `@${user.username}` : `Creator ID ${user.id}`}
          {handles.map(handle => ` · @${handle.replace(/^@/, '')}`).join('')}
        </small>
      </div>
      {user.username ? (
        <a
          aria-label={`Preview ${user.name || user.username}'s shop`}
          title='Preview shop'
          className='circle-shop-link'
          href={getCreatorProfileUrl(user.username)}
          target='_blank'
          rel='noopener noreferrer'
        >
          <FontAwesomeIcon icon={faEye} />
        </a>
      ) : (
        <small className='circle-creator-unavailable'>Public profile unavailable</small>
      )}
    </>
  );
}

CreatorInfo.propTypes = { user: PropTypes.object.isRequired };

export default CreatorInfo;
